import * as React from 'react';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
      className='feather feather-info'
      {...props}
    >
      <circle cx={12} cy={12} r={10} />
      <path d='M12 16L12 12' />
      <path d='M12 8L12.01 8' />
    </svg>
  );
};

export default SvgComponent;
